import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import appsInfo from '../../helpers/InitialAppsState';
import DashboardVideoModal from '../../components/modals/DashboardVideoModal';

import { IconButton, Typography } from '@material-ui/core';

class EmptyAssets extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDashboardVideoModal: false,
        };

        // opener button DOM node for focus return after modal closes
        this.openButtonEl = null;
        this.setOpenButtonEl = (el) => { this.openButtonEl = el; };
    }

    onOpenDashboardVideo = () => {
        this.setState({
            showDashboardVideoModal: true,
        });
    };

    onCloseDashboardVideo = () => {
        this.setState({
            showDashboardVideoModal: false,
        });
    };

    render() {
        const { application, classes } = this.props;

        const appInfo = appsInfo[application];
        if (!appInfo) {
            return null;
        }

        const illustrationLocation = `/assets/no_${appInfo.name.toLowerCase()}.svg`;
        const iconClasses = classNames('material-icons', 'large', classes.icon);
        const isAllApp = application === 'all';
        const appName = isAllApp ? 'assets' : appInfo.name.toLowerCase();

        return (
            <div>
                <DashboardVideoModal
                    show={this.state.showDashboardVideoModal}
                    onClose={this.onCloseDashboardVideo}
                    videoId="sgtvqidgd6"
                    returnFocusEl={this.openButtonEl}
                />

                <div className={classes.container}>
                    <div className={classes.wrapper}>
                        <img
                            className={classes.image}
                            src={illustrationLocation}
                            alt="No assets"
                        />

                        <Typography className={classes.title}>
                            No {appName} yet!
                        </Typography>

                        {!isAllApp && (
                            <Typography className={classes.subtitle}>
                                To add a {appName} click on{' '}
                                <span className={classes.green}>
                                    <b>the green button (+) </b>
                                </span>
                                above.
                            </Typography>
                        )}
                    </div>
                </div>

                <div className={classes.video}>
                    <IconButton
                        className={classes.videoButton}
                        onClick={this.onOpenDashboardVideo}
                        onKeyDown={(e) => {
                            const isEnter = e.key === 'Enter' || e.keyCode === 13;
                            const isSpace = e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 32;
                            if (isEnter || isSpace) {
                                e.preventDefault();
                                this.onOpenDashboardVideo();
                            }
                        }}
                        // Material-UI v3: capture the DOM node for focus return
                        buttonRef={this.setOpenButtonEl}
                        aria-label="Open get started video"
                    >
                        <i className={iconClasses}>play_circle_outline</i>
                    </IconButton>

                    <Typography className={classes.videoText}>
                        Having trouble using the dashboard? You can{' '}
                        <a
                            className={classes.clickHere}
                            onClick={this.onOpenDashboardVideo}
                        >
                            click here
                        </a>{' '}
                        to watch our <b>Get started video</b> and learn more.
                    </Typography>
                </div>
            </div>
        );
    }
}

EmptyAssets.propTypes = {
    appsInfo: PropTypes.any,
    application: PropTypes.string,
    classes: PropTypes.object,
};

const style = ({ palette }) => ({
    wrapper: {
        margin: '0 auto',
        textAlign: 'center',
    },
    title: {
        fontSize: 26,
        fontWeight: 'bold',
        marginTop: 16,
        marginBottom: 12,
    },
    container: {
        background: 'white',
        borderRadius: 4,
        height: 330,
        width: 960,
    },
    video: {
        background: 'rgb(247, 253, 253)',
        borderRadius: 4,
        border: '1px dashed rgb(0, 169, 157)',
        height: 70,
        width: 960,
        marginTop: 15,
        display: 'flex',
    },
    videoText: {
        color: 'rgb(26, 26, 26)',
        fontSize: 14,
        fontWeight: 'normal',
        height: 20,
        letterSpacing: 0,
        textAlign: 'center',
        marginTop: 25,
        width: 690,
        marginLeft: 45,
    },
    videoButton: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    subtitle: {
        fontSize: 15,
    },
    image: {
        marginTop: 49,
    },
    green: {
        color: palette.primary.main,
    },
    icon: {
        color: palette.primary.main,
        fontSize: '2em',
        marginTop: 35,
        marginLeft: 100,
    },
    clickHere: {
        cursor: 'pointer',
        color: palette.primary.main,
        fontWeight: 'bold',
        textDecoration: 'underline',
    },
});

export default injectSheet(style)(EmptyAssets);



// WEBPACK FOOTER //
// ./src/components/assets/EmptyAssets.js